export default __webpack_public_path__ + "static/media/balloon2.3b2629d0.png";